export interface EmptyIssueReason {
	title: string
	text: string
	showSettingsLink: boolean
}

/**
 * Why the picker came back with nothing. An empty list on its own reads as a
 * broken integration, so each case names what to do next.
 */
export function emptyIssueReason({
	query,
	hidesImported,
	importedCount,
}: {
	query: string
	hidesImported: boolean
	importedCount: number
}): EmptyIssueReason {
	if (query.trim()) {
		return {
			title: "No issues found",
			text: `Nothing matches "${query.trim()}" in your visible Linear teams.`,
			showSettingsLink: false,
		}
	}

	if (hidesImported && importedCount > 0) {
		return {
			title: "Everything is imported",
			text: "Every issue from your visible Linear teams is already here. Make a team visible in the Linear settings to import more.",
			showSettingsLink: true,
		}
	}

	return {
		title: "No issues found",
		text: "Issues come from the teams you made visible in the Linear settings.",
		showSettingsLink: true,
	}
}
